import PlayerCard from '../PlayerCard'
import './index.css'

const GridPlayersSeven = ({players, vote}) => {


    return (
        <div className="grid-player-seven-container">
            {
                players?.map((player, i) => (<div key={i} className="grid-player-seven-item">
                    <PlayerCard player={player} vote={vote} />

                </div>))
            }
            

        </div>
    )
}

export default GridPlayersSeven